import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { useTranslation } from 'react-i18next';

/**
 * Toolbar icon button to toggle suggest mode (propose modification).
 */
const SuggestModeButton = ({ active, onClick, disabled }) => {
  const { t } = useTranslation();
  const tooltipText = disabled
    ? t('suggest_mode_locked', 'Mode suggestion verrouillé (relecteur)')
    : active ? t('suggest_mode') : t('propose_modification');
  return (
    <Tooltip
      title={tooltipText}
      placement="bottom"
    >
      <span>
        <IconButton
          size="small"
          onClick={disabled ? undefined : onClick}
          disabled={disabled}
          sx={{
            color: active ? 'primary.main' : 'text.disabled',
            bgcolor: active ? 'rgba(25, 118, 210, 0.12)' : 'transparent',
            borderRadius: 1,
            transition: 'background-color 0.15s ease, color 0.15s ease',
            '&:hover': {
              bgcolor: active
                ? 'rgba(25, 118, 210, 0.2)'
                : 'action.hover',
            },
            '&.Mui-disabled': {
              color: 'primary.main',
              bgcolor: 'rgba(25, 118, 210, 0.12)',
              opacity: 0.7,
            },
          }}
        >
          <RateReviewIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default SuggestModeButton;
